import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { map, get } from 'lodash-es'
import { IconComponent, LoaderComponent } from '../../../../components'

import './ExpandedListActionsComponent.scss'

const actionIcons = [
  ['send', { name: 'email-fill', size: [16, 16] }],
  ['edit', { name: 'edit', size: [14, 14] }],
  ['delete', { name: 'delete', size: [14, 14] }],
]

const loadingIcon = (
  <LoaderComponent
    key="loading"
    className="action-button no-padding"
    size="small"
  />
)

const ExpandedListActionsComponent = (props) => {
  const {
    speakerId,
    onSendClick,
    openCrudModal,
    sendInviteSpeakerId,
    viewOnly,
  } = props
  const actionHandlers = {
    send: () => onSendClick(speakerId),
    edit: () => openCrudModal('edit', speakerId),
    delete: () => openCrudModal('delete', speakerId),
  }

  return (
    <div
      className={classnames('expanded-list-actions-component', {
        disabled: viewOnly,
      })}
    >
      {map(actionIcons, (icon) => {
        const onClick = get(actionHandlers, icon[0])
        let renderIcon = (
          <IconComponent
            {...icon[1]}
            color={viewOnly ? 'CCC' : 'AAAAAA'}
            {...(!viewOnly && { onClick })}
            className="action-button"
            key={icon[0]}
            displayBoxOnHover
          />
        )

        if (icon[0] === 'send' && speakerId === sendInviteSpeakerId) {
          renderIcon = loadingIcon
        }

        return renderIcon
      })}
    </div>
  )
}

ExpandedListActionsComponent.propTypes = {
  speakerId: PropTypes.string,
  openCrudModal: PropTypes.func,
  onSendClick: PropTypes.func,
  sendInviteSpeakerId: PropTypes.string,
  viewOnly: PropTypes.bool,
}

export default ExpandedListActionsComponent
